module.exports = __webpack_public_path__ + "img/286.47cb0668.jpg";